import type { SVGProps } from 'react';

const SvgPurchaseFrequency = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="purchase-frequency">
      <path d="m22.41 8 5.53.95h.13a.76.76 0 0 0 .74-.6l1.1-5.65-1.47-.29-.76 3.88A15.3 15.3 0 0 0 1.19 20.05l1.45-.38A13.81 13.81 0 0 1 26.45 7.16l-3.79-.65ZM30.81 12.3l-1.45.38A13.81 13.81 0 0 1 5.28 24.87l3.89.66.25-1.47-5.53-.95a.74.74 0 0 0-.89.59l-1.1 5.65 1.47.28.74-3.79a15.3 15.3 0 0 0 26.7-13.54" />
      <path d="M20.64 13.37V13a3.14 3.14 0 0 0-3.13-3.14h-.64v-2h-1.5v2h-.52a3.29 3.29 0 0 0 0 6.58h.52V20h-.65a1.63 1.63 0 0 1-1.63-1.63h-1.5a3.14 3.14 0 0 0 3.13 3.13h.65v2h1.5v-2h.52a3.29 3.29 0 0 0 0-6.58h-.52v-3.61h.64A1.63 1.63 0 0 1 19.14 13v.42Zm-3.25 3a1.79 1.79 0 0 1 0 3.58h-.52v-3.56Zm-2-1.5h-.52a1.79 1.79 0 0 1 0-3.58h.52Z" />
    </g>
  </svg>
);

export default SvgPurchaseFrequency;
